module.exports = __webpack_public_path__ + "static/media/task4Planet1.ecacd60e.png";